export default "/_next/static/images/89ed6d834df3a5217b1eb147713ab639.jpg";